// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"357":"ebca84bb","405":"357f2686"}[chunkId] + ".chunk.css";
};